import React from 'react';
import { Link } from 'react-router-dom';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from 'recharts';
import { MessageSquareIcon, MicIcon, ClipboardIcon, CameraIcon, ArrowRightIcon, UploadIcon } from 'lucide-react';
import { WhatsApp } from '@mui/icons-material';
import { SoftCard } from '../components';
export const MultiModalInputs = ({ submissionsByMode, CustomTooltip }) => {
    const renderModeIcon = (modeName) => {
        switch (modeName.toLowerCase()) {
            case 'chat':
                return React.createElement(MessageSquareIcon, { className: "w-4 h-4 mr-1 text-indigo-500" });
            case 'speech':
                return React.createElement(MicIcon, { className: "w-4 h-4 mr-1 text-orange-500" });
            case 'form':
                return React.createElement(ClipboardIcon, { className: "w-4 h-4 mr-1 text-emerald-500" });
            case 'camera':
                return React.createElement(CameraIcon, { className: "w-4 h-4 mr-1 text-violet-500" });
            case 'file upload':
                return React.createElement(UploadIcon, { className: "w-4 h-4 mr-1 text-gray-500" });
            case 'whatsapp':
                return React.createElement(WhatsApp, { className: "w-4 h-4 mr-1 text-gray-500" });
            default:
                return React.createElement(ClipboardIcon, { className: "w-4 h-4 mr-1 text-gray-500" });
        }
    };
    return (React.createElement(SoftCard, { header: {
            title: "Use of multi-modal Inputs",
            subtitle: "How users are interacting with your forms"
        }, footer: {
            children: (React.createElement("div", { className: "flex justify-between items-center" },
                React.createElement("div", { className: "flex space-x-4" }, submissionsByMode.map((item, index) => (React.createElement("div", { key: index, className: "flex items-center text-sm text-gray-600" },
                    renderModeIcon(item.name),
                    item.name)))),
                React.createElement(Link, { to: "/submissions", className: "text-sm font-medium text-orange-500 hover:text-orange-600 flex items-center" },
                    "View Details",
                    React.createElement(ArrowRightIcon, { className: "w-4 h-4 ml-1" }))))
        }, className: "mb-6" },
        React.createElement("div", { className: "flex flex-col md:flex-row items-center" },
            React.createElement("div", { className: "w-full md:w-1/2 h-64" },
                React.createElement(ResponsiveContainer, { width: "100%", height: "100%" },
                    React.createElement(PieChart, null,
                        React.createElement(Pie, { data: submissionsByMode, cx: "50%", cy: "50%", labelLine: false, outerRadius: 80, fill: "#8884d8", dataKey: "value", label: ({ name, percent }) => `${(percent * 100).toFixed(0)}%` }, submissionsByMode.map((entry, index) => React.createElement(Cell, { key: `cell-${index}`, fill: entry.color }))),
                        React.createElement(Tooltip, { content: React.createElement(CustomTooltip, { active: false, payload: [], label: "" }) })))),
            React.createElement("div", { className: "w-full md:w-1/2 mt-4 md:mt-0" },
                React.createElement("div", { className: "space-y-4" }, submissionsByMode.map((entry, index) => (React.createElement("div", { key: index, className: "flex items-center" },
                    React.createElement("div", { className: "w-4 h-4 rounded-full mr-3", style: {
                            backgroundColor: entry.color
                        } }),
                    React.createElement("div", { className: "flex-1" },
                        React.createElement("div", { className: "flex justify-between" },
                            React.createElement("span", { className: "font-medium text-gray-700" }, entry.name),
                            React.createElement("span", { className: "text-gray-600" },
                                entry.value,
                                " interactions")),
                        React.createElement("div", { className: "w-full bg-gray-100 rounded-full h-1.5 mt-1" },
                            React.createElement("div", { className: "h-1.5 rounded-full", style: {
                                    width: `${entry.value / 100 * 100}%`,
                                    backgroundColor: entry.color
                                } })))))))))));
};
export default MultiModalInputs;
